import Api from "utils/api";
import { decryptJSON } from "global/security";

function ensurePayload(response, fallbackMessage) {
  if (!response?.success || !response?.data) {
    throw new Error(response?.message || fallbackMessage);
  }

  return decryptJSON(response.data);
}

async function postWorkspaceMailAction(path, fallbackMessage, expectEncrypted = false) {
  const { response, error } = await Api(path, "post");

  if (error) {
    throw new Error(error?.message || fallbackMessage);
  }

  if (expectEncrypted) {
    return ensurePayload(response, fallbackMessage);
  }

  return response;
}

export async function getOrganizationAccountsV2() {
  const { response, error } = await Api("/super_admin_v2/organizations", "get");

  if (error) {
    throw new Error(error?.message || "Failed to load organization accounts");
  }

  return ensurePayload(response, "Organization accounts are unavailable");
}

export async function getOrganizationAccountDetailV2(accountId) {
  const { response, error } = await Api(`/super_admin_v2/organizations/${accountId}`, "get");

  if (error) {
    throw new Error(error?.message || "Failed to load organization detail");
  }

  return ensurePayload(response, "Organization detail is unavailable");
}

export async function resendWorkspaceCreatePasswordV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/resend-create-password`,
    "Failed to send create password email"
  );
}

export async function resendWorkspaceWalletEmailV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/resend-wallet-email`,
    "Failed to send add to wallet email"
  );
}

export async function generateWorkspaceCreatePasswordLinkV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/generate-create-password-link`,
    "Failed to generate create password link",
    true
  );
}

export async function generateWorkspaceWalletLinkV2(userId) {
  return postWorkspaceMailAction(
    `/super_admin_v2/workspace-users/${userId}/generate-wallet-link`,
    "Failed to generate wallet link",
    true
  );
}
